import React from "react";
import ReactDOM from "react-dom/client";
import PortfolioWebsite from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PortfolioWebsite />
  </React.StrictMode>
);
